"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _personalDetailsUtils = require("./personalDetailsUtils");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Expected input:
 *
 * links: {
      "facebook": "https:/facebook.com",
      "twitter": "https:/twitter.com"
    }
 *
 * */
const SocialMediaIcons = props => {
  let toRender = [];
  for (const [key, value] of Object.entries(props.links)) {
    toRender.push( /*#__PURE__*/_react.default.createElement("a", {
      href: value,
      key: "social-media-link-".concat(key)
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "con-social-media__image",
      src: (0, _personalDetailsUtils.getSocialMediaIcon)(key),
      alt: "".concat(key, " icon")
    })));
  }
  return toRender;
};
SocialMediaIcons.propTypes = {
  links: _propTypes.default.object
};
var _default = exports.default = SocialMediaIcons;